import { Api, SignalCategory } from '@firmable/contracts';
import { DateRangeType } from 'constants/signal';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface FilterState {
  category: SignalCategory;
  dateRange: DateRangeType;
  selectedSignal: {
    company: Api.Signals.SignalType | null;
    people: Api.Signals.SignalType | null;
    intent: string | null;
  };
}

export interface SelectSignalParams {
  signal: Api.Signals.SignalType | null;
  category: SignalCategory;
}

export interface ClearParams {
  category: SignalCategory;
}

type FilterActions = {
  changeCategory: (mode: SignalCategory) => void;
  selectSignal: (params: SelectSignalParams) => void;
  clear: (params: ClearParams) => void;
  reset: () => void;
};

/**
 * To manage the column filters and the category (company/people) on signals page
 */
const useFilter = create<FilterState & FilterActions>()(
  devtools(
    immer((set) => ({
      category: 'company',
      dateRange: 90, // Default to 90 days
      selectedSignal: { company: null, people: null, intent: null },
      changeCategory: (category: SignalCategory) => set({ category }, false, { type: 'CHANGE_CATEGORY' }),
      selectSignal: ({ signal, category }: SelectSignalParams) =>
        set(
          (state) => {
            if (category === 'company' || category === 'people' || category === 'intent') {
              state.selectedSignal[category] = signal;
            }
          },
          false,
          { type: 'SELECT_SIGNAL' },
        ),
      clear: ({ category }: ClearParams) =>
        set(
          (state) => {
            if (category === 'company' || category === 'people' || category === 'intent') {
              state.selectedSignal[category] = null;
            }
          },
          false,
          { type: 'CLEAR_SELECTED_SIGNAL' },
        ),
      reset: () =>
        set(
          (state) => {
            state.selectedSignal = { company: null, people: null, intent: null };
          },
          false,
          { type: 'RESET' },
        ),
    })),
    {
      store: 'ManageSignalsActions',
    },
  ),
);

export { useFilter };
